// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__31iBE","productName":"Table_productName__dWl1w"};